// Enlarged view for the EU harmonised notice and the GARAN label.
// Regulation (EU) 2025/1960 and the Commission guidelines require the full artwork on the *first*
// mouse roll-over, click or tap, so mouse hover opens it without waiting for a click; touch and
// keyboard rely on the native <details> toggle, which also works before this script loads.
if (!customElements.get('eu-guarantee-popover')) {
  customElements.define(
    'eu-guarantee-popover',
    class EuGuaranteePopover extends HTMLElement {
      constructor() {
        super();
        this.onDocumentClick = this.onDocumentClick.bind(this);
      }

      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.openedByHover = false;

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimer);
          if (!this.details.open) {
            this.details.open = true;
            this.openedByHover = true;
          }
        });

        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse' || !this.openedByHover) return;
          this.closeTimer = setTimeout(() => this.close(), 200);
        });

        // A click right after hovering must not toggle the view shut again; it pins it open.
        this.summary.addEventListener('click', (event) => {
          if (this.details.open && this.openedByHover) {
            event.preventDefault();
            this.openedByHover = false;
          }
        });

        this.querySelector('[data-popover-close]')?.addEventListener('click', () => this.close(true));

        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape' && this.details.open) this.close(true);
        });

        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        clearTimeout(this.closeTimer);
      }

      onDocumentClick(event) {
        if (this.details.open && !this.contains(event.target)) this.close();
      }

      close(restoreFocus = false) {
        clearTimeout(this.closeTimer);
        this.details.open = false;
        this.openedByHover = false;
        if (restoreFocus) this.summary.focus();
      }
    }
  );
}

// The GARAN label shows the selected variant's SKU, but it sits outside the parts Dawn refreshes
// on variant change, so the slot swaps in its counterpart from the re-rendered section.
if (!customElements.get('eu-guarantee-slot')) {
  customElements.define(
    'eu-guarantee-slot',
    class EuGuaranteeSlot extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.sectionId) return;
          const fresh = data.html.getElementById(this.id);
          if (fresh) this.innerHTML = fresh.innerHTML;
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    }
  );
}
